export const colors = {
  primary: "#5965E0",
  secondary: "#4953B8",
  green: "#4CD62B",
  red: "#E83F5B",
  black: "#1e1e1e",
  white: "#FFFFFF",
  titles: "#2E384D",
  blueText: '#B3B9FF',
  text: '#666666',
  background: "#F2F3F5",
};
